<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    // Using shorthand syntax...
    layout: WebLayout,
}
</script>
<script setup>
import SEOHead from '@/components/SEOHead.vue'
</script>

<template>
    <SEOHead
        title="Impresum - Kulfood"
        description="Impresum Kulfood. Kontaktni podatki, davčna in matična številka ter informacije o upravljavcu spletne strani."
        keywords="impresum, Kulfood.si"
        canonical="/impresum"
        image="/images/web/kulfood-impressum.png"
        :structured-data="{
            '@type': 'WebSite',
            'name': 'Kulfood.si',
            'url': 'https://kulfood.si',
            'description': 'Impresum Kulfood. Kontaktni podatki, davčna in matična številka ter informacije o upravljavcu spletne strani.',
        }"
        type="website"
    />
    <div class="container mx-auto px-4 py-12">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-4xl font-bold text-gray-900 mb-8">Impresum</h1>
            
            <div class="prose prose-lg max-w-none">
                <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Impresum – Kulfood.si</h2>
                
                <p class="text-gray-600 mb-6">
                    Spletno mesto: <a href="https://kulfood.si" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">https://kulfood.si</a>
                </p>

                <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Blagovna znamka</h2>
                
                <p class="text-gray-600 mb-6">
                    Kulfood
                </p>

                <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Upravljavec strani / ponudnik storitev</h2>
                
                <p class="text-gray-600 mb-4">
                    <strong>Kulfood</strong><br>
                </p>
                
                <p class="text-gray-600 mb-4">
                    Matična številka: 7397950000<br>
                    Davčna številka: SI 75339358
                </p>

                <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Kontaktni podatki</h2>
                
                <p class="text-gray-600 mb-4">
                    E-naslov: <strong>info@kulfood.si</strong><br>
                    Telefon: <strong>+386 40 723 726</strong>
                </p>

                <h2 class="text-2xl font-semibold text-gray-900 mt-8 mb-4">Odgovorna oseba za vsebino</h2>
                
                <p class="text-gray-600 mb-6">
                    Rok Vaupotič
                </p>

                <p class="text-sm text-gray-500 mt-8">
                    Datum zadnje posodobitve: 30. 12. 2025
                </p>
            </div>
        </div>
    </div>
</template>
